function getNumberFromstring(value) {
  if (!value) return 0;
  return Number.parseFloat(value.toString().replaceAll(/[^0-9.]/g, "")) || 0;
}

function formatVariantMoney(cents) {
  const shopifyCurrency = globalThis.Shopify?.currency;
  const currencyCode =
    typeof shopifyCurrency === "string"
      ? shopifyCurrency
      : shopifyCurrency?.active || "CAD";
  const amount = (cents || 0) / 100;
  const hasFractionalAmount = !Number.isInteger(amount);
  const formattedAmount = new Intl.NumberFormat("en-CA", {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: hasFractionalAmount ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(amount);

  return formattedAmount;
}

if (!customElements.get("variant-selects")) {
  class VariantSelects extends HTMLElement {
    initialUrl;
    variantInCartBadgeSvg = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.2836 9.01807L15.9678 3.41877C16.0035 3.29973 16.0096 3.17445 15.9857 3.05277C15.9618 2.9311 15.9085 2.81636 15.8299 2.71758C15.7514 2.6188 15.6498 2.53868 15.5332 2.48352C15.4165 2.42836 15.288 2.39967 15.1577 2.3997H4.01679L3.51574 0.595925C3.46832 0.42513 3.36272 0.274047 3.21542 0.166246C3.06811 0.0584447 2.88739 -1.04106e-05 2.70144 1.39069e-09H0.842093C0.618756 1.39069e-09 0.404566 0.0842749 0.246643 0.234285C0.0887203 0.384295 0 0.587753 0 0.7999C0 1.01205 0.0887203 1.2155 0.246643 1.36551C0.404566 1.51552 0.618756 1.5998 0.842093 1.5998H2.05302L2.55828 3.40357V3.41157V3.41877L4.24247 9.01807L4.87067 11.4066C4.45479 11.5817 4.09642 11.8603 3.8334 12.2129C3.57038 12.5655 3.41247 12.979 3.37635 13.4098C3.34023 13.8405 3.42724 14.2726 3.62818 14.6603C3.82913 15.048 4.13655 15.3769 4.518 15.6124C4.89945 15.8479 5.34076 15.9812 5.79534 15.9981C6.24991 16.0151 6.70088 15.9152 7.10063 15.7089C7.50038 15.5026 7.83406 15.1976 8.06645 14.8261C8.29884 14.4546 8.42131 14.0304 8.42093 13.5983C8.41814 13.3252 8.36572 13.0546 8.26599 12.7984H10.2601C10.1603 13.0546 10.1079 13.3252 10.1051 13.5983C10.1051 14.0729 10.2533 14.5369 10.5309 14.9315C10.8085 15.3261 11.203 15.6337 11.6646 15.8153C12.1263 15.997 12.6342 16.0445 13.1243 15.9519C13.6143 15.8593 14.0644 15.6307 14.4177 15.2951C14.7711 14.9595 15.0117 14.532 15.1091 14.0665C15.2066 13.601 15.1566 13.1185 14.9654 12.68C14.7742 12.2415 14.4504 11.8667 14.0349 11.603C13.6195 11.3393 13.1311 11.1986 12.6314 11.1986H6.55149L6.13044 9.5988H13.4735C13.6566 9.59884 13.8348 9.54218 13.981 9.43738C14.1272 9.33259 14.2334 9.18538 14.2836 9.01807ZM12.6314 12.7984C12.7979 12.7984 12.9608 12.8453 13.0992 12.9332C13.2377 13.0211 13.3457 13.146 13.4094 13.2922C13.4731 13.4384 13.4898 13.5992 13.4573 13.7543C13.4248 13.9095 13.3446 14.052 13.2268 14.1639C13.1091 14.2758 12.959 14.352 12.7957 14.3828C12.6323 14.4137 12.463 14.3979 12.3091 14.3373C12.1553 14.2768 12.0238 14.1742 11.9312 14.0427C11.8387 13.9112 11.7893 13.7565 11.7893 13.5983C11.7893 13.3861 11.878 13.1827 12.0359 13.0327C12.1939 12.8827 12.4081 12.7984 12.6314 12.7984ZM6.73675 13.5983C6.73675 13.7565 6.68736 13.9112 6.59483 14.0427C6.5023 14.1742 6.37078 14.2768 6.21691 14.3373C6.06304 14.3979 5.89372 14.4137 5.73037 14.3828C5.56702 14.352 5.41697 14.2758 5.2992 14.1639C5.18143 14.052 5.10123 13.9095 5.06874 13.7543C5.03625 13.5992 5.05292 13.4384 5.11666 13.2922C5.1804 13.146 5.28833 13.0211 5.42681 12.9332C5.56529 12.8453 5.7281 12.7984 5.89465 12.7984C6.11799 12.7984 6.33218 12.8827 6.4901 13.0327C6.64803 13.1827 6.73675 13.3861 6.73675 13.5983ZM10.9472 6.3992H10.1051V7.1991C10.1051 7.41124 10.0164 7.6147 9.85848 7.76471C9.70055 7.91472 9.48636 7.999 9.26303 7.999C9.03969 7.999 8.8255 7.91472 8.66758 7.76471C8.50965 7.6147 8.42093 7.41124 8.42093 7.1991V6.3992H7.57884C7.3555 6.3992 7.14131 6.31492 6.98339 6.16491C6.82547 6.0149 6.73675 5.81145 6.73675 5.5993C6.73675 5.38715 6.82547 5.18369 6.98339 5.03368C7.14131 4.88367 7.3555 4.7994 7.57884 4.7994H8.42093V3.9995C8.42093 3.78735 8.50965 3.58389 8.66758 3.43388C8.8255 3.28387 9.03969 3.1996 9.26303 3.1996C9.48636 3.1996 9.70055 3.28387 9.85848 3.43388C10.0164 3.58389 10.1051 3.78735 10.1051 3.9995V4.7994H10.9472C11.1705 4.7994 11.3847 4.88367 11.5427 5.03368C11.7006 5.18369 11.7893 5.38715 11.7893 5.5993C11.7893 5.81145 11.7006 6.0149 11.5427 6.16491C11.3847 6.31492 11.1705 6.3992 10.9472 6.3992Z" fill="white"/>
                </svg>`;
    constructor() {
      super();
      this.productSection = this.closest(".product-main--section");
      this.productInfo = this.closest("product-info");
      this.hostSection = this.closest("section");
      this.renderProductInfoController = null;
      this.cartData = null;
      this.cartDataFetchedAt = 0;
      this.cartRequestPromise = null;
      this.addEventListener("change", this.onVariantChange);

      this.checkIfVariantIsInCart();
      this.checkIfAllVariantsAreInTheCart();
      this.initialUrl = window.location.search;

      this._forceMedaGroupingUpdateOnLoad();
    }

    _forceMedaGroupingUpdateOnLoad() {
      document.addEventListener("DOMContentLoaded", () => {
        const variantPromise = new Promise((resolve) => {
          if (this.closest("product-info") && !this.currentVariant) {
            this.onVariantChange();
          }
          resolve();
        });

        variantPromise.then(() => {
          const mediaItems = document.querySelectorAll(".product__media");
          mediaItems.forEach((item) => {
            const imgs = item.querySelectorAll("img.lazy-image[data-src]");
            imgs.forEach((img) => {
              const dataSrc = img.getAttribute("data-src");
              if (dataSrc) {
                const preload = new Image();
                preload.src = dataSrc;
              }
            });
          });
        });
      });
    }

    onVariantChange() {
      if (window.location.href.includes("/pages/suites")) {
      }
      this.updateOptions();
      this.updateMasterId();
      this.updateVariantTitle();
      this.toggleAddButton(true, "", false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantStatuses();

      if (!this.currentVariant) {
        this.toggleAddButton(true, "", true);
        this.setUnavailable();
        this.updateMedia();
      } else {
        this.updateVisiblePricesFromCurrentVariant();
        this.updateMediaGrouping();
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }

      const productInfo = this.getProductInfo();
      const itemsInStock = productInfo?.querySelector(".items-in-stock");
      const productVariantSelected = productInfo?.querySelectorAll(
        ".product-variant:not(.hide-variant-option):not(.hide-variant-option--force)",
      );
      if (itemsInStock && productVariantSelected) {
        itemsInStock.textContent =
          Array.from(productVariantSelected).filter(
            (el) => el.dataset.invertory > 0,
          ).length + " In-Stock";
      }

      this.checkIfAllVariantsAreInTheCart();
      if (this.initialUrl.includes("old_key=")) {
        window.location.reload();
      }

      this.refreshMediaSliders();
    }

    updateVariantTitle() {
      const productSection = this.getProductSection();
      if (!productSection) return;

      const variantTitle = this.currentVariant?.title || "";
      const barcode = this.currentVariant?.barcode || "";

      productSection
        .querySelectorAll(".product__variant-title")
        .forEach((el) => {
          const conditionLabel = el.dataset.conditionLabel;
          const titleMode = el.dataset.variantTitleMode || "full";
          const valueElement = el.querySelector(
            ".product__variant-title-value",
          );
          const barcodeElement = el.querySelector(
            ".product__variant-title-barcode",
          );
          const formattedVariantTitle =
            titleMode === "compact"
              ? this.formatCompactVariantTitle(variantTitle)
              : variantTitle;

          if (valueElement) {
            valueElement.textContent = formattedVariantTitle;
          }

          if (barcodeElement) {
            barcodeElement.textContent = barcode;
            barcodeElement.hidden = !barcode;
          }

          if (!valueElement) {
            if (!conditionLabel) return;

            el.textContent = variantTitle
              ? `${conditionLabel} ${variantTitle}`
              : conditionLabel;
          }
        });
    }

    formatCompactVariantTitle(title) {
      if (!title) return "";

      const titleParts = title.split(" - ");
      if (titleParts.length <= 1) return title;

      titleParts.pop();
      return titleParts.join(" - ");
    }

    updateOptions() {
      this.options = Array.from(
        this.querySelectorAll("select, fieldset"),
        (element) => {
          if (element.tagName === "SELECT") {
            return element.value;
          }
          if (element.tagName === "FIELDSET") {
            return Array.from(element.querySelectorAll("input")).find(
              (radio) => radio.checked,
            )?.value;
          }
        },
      );
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => this.options[index] === option)
          .includes(false);
      });
    }

    updateSelectedSwatchValue({ target }) {
      const { name, value, tagName } = target;

      if (tagName === "SELECT" && target.selectedOptions.length) {
        const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
        const selectedDropdownSwatchValue = this.querySelector(
          `[data-selected-dropdown-swatch="${name}"] > .swatch`,
        );
        if (!selectedDropdownSwatchValue) return;
        if (swatchValue) {
          selectedDropdownSwatchValue.style.setProperty(
            "--swatch--background",
            swatchValue,
          );
          selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
        } else {
          selectedDropdownSwatchValue.style.setProperty(
            "--swatch--background",
            "unset",
          );
          selectedDropdownSwatchValue.classList.add("swatch--unavailable");
        }
      } else if (tagName === "INPUT" && target.type === "radio") {
        const selectedSwatchValue = this.querySelector(
          `[data-selected-swatch-value="${name}"]`,
        );
        if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
      }
    }

    updateMedia() {
      const productSection = this.getProductSection();
      if (!productSection) return;

      const mediaGalleries = productSection.querySelectorAll(
        `[id^="MediaGallery-${this.dataset.section}"]`,
      );
      const fallbackMediaId = this.getFirstVisibleMediaId(productSection);

      if (!this.currentVariant) {
        const defaultMediaId =
          productSection
            .querySelector("[data-main-media]")
            ?.getAttribute("data-media-id") || fallbackMediaId;
        if (!defaultMediaId) return;

        mediaGalleries.forEach((mediaGallery) =>
          mediaGallery.setActiveMedia(defaultMediaId, false),
        );
        return;
      }
      const featuredMediaId = this.currentVariant.featured_media
        ? `${this.dataset.section}-${this.currentVariant.featured_media.id}`
        : null;
      const mediaIdToActivate =
        (featuredMediaId &&
          this.isMediaVisible(productSection, featuredMediaId) &&
          featuredMediaId) ||
        fallbackMediaId;
      if (!mediaIdToActivate) return;

      mediaGalleries.forEach((mediaGallery) =>
        mediaGallery.setActiveMedia(mediaIdToActivate, false),
      );
      const modalContent = document.querySelector(
        `#ProductModal-${this.dataset.section} .product-media-modal__content`,
      );
      if (!modalContent) return;
      const newMediaModal = modalContent.querySelector(
        `[data-media-id="${mediaIdToActivate.replace(`${this.dataset.section}-`, "")}"]`,
      );
      if (newMediaModal) {
        modalContent.prepend(newMediaModal);
      }
    }

    updateMediaGrouping() {
      const productSection = this.getProductSection();
      const productInfo = this.getProductInfo();
      if (!productSection) return;

      const variantId = this.currentVariant.id;
      const condition =
        productInfo?.querySelector(".ppf-checked")?.dataset.value;
      const shouldShowUngroupedMedia =
        document.body.classList.contains("customer-type--consumer") ||
        document.body.classList.contains("customer-type--wholesaler");

      productSection
        .querySelectorAll(".product__media-item, .thumbnail-list__item")
        .forEach((mediaItem) => {
          const mediaVariantGrouping = mediaItem.getAttribute(
            "data-variant-grouping-ids",
          );
          const isFeaturedMedia = mediaItem.getAttribute("data-featured-media");
          if (
            isFeaturedMedia ||
            (mediaVariantGrouping && mediaVariantGrouping.includes(variantId))
          ) {
            mediaItem.classList.remove("hide-image");
          } else {
            if (mediaVariantGrouping == "" && shouldShowUngroupedMedia) {
              mediaItem.classList.remove("hide-image");
            } else {
              mediaItem.classList.add("hide-image");
            }
          }
        });
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      if (window.location.href.includes("pages/suites")) {
        const urlParams = new URLSearchParams(window.location.search);
        let url = `/pages/suites?product_1=${urlParams.get(
          "product_1",
        )}&product_2=${urlParams.get("product_2")}`;

        let currentVariants = urlParams.get("variants");

        if (!currentVariants) {
          url += `&variants=${this.currentVariant.id}`;
        } else {
          let currentVariantsArr = currentVariants
            .split(",")
            .map((variant) => parseInt(variant));
          let variantsSelected = variantsArrSuite.find((arr) =>
            arr.includes(this.currentVariant.id),
          );

          let result = currentVariantsArr.map((variantInUrl) => {
            return variantsSelected.includes(variantInUrl)
              ? this.currentVariant.id
              : variantInUrl;
          });

          !result.includes(this.currentVariant.id) &&
            result.push(this.currentVariant.id);
          url += `&variants=${result.join(",")}`;
        }

        window.history.replaceState({}, "", url);

        return;
      }
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`,
      );
    }

    updateShareUrl() {
      const shareButton = document.getElementById(
        `Share-${this.dataset.section}`,
      );
      if (!shareButton || !shareButton.updateUrl) return;
      shareButton.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
      );
    }

    getProductForm() {
      return document.getElementById(`product-form-${this.dataset.section}`);
    }

    getConditionFilterConfig() {
      return [
        "Refurbished",
        "Open Box - Excellent",
        "Original",
        "Open Box - Good",
        "Open Box - Fair",
      ];
    }

    maybeSelectNextAvailableVariantForCondition() {
      if (!document.body.classList.contains("customer-type--consumer")) return;

      const activeCondition = this.getConditionFilterConfig().find(
        (condition) =>
          document
            .querySelector(`.js-cb-filter[data-value="${condition}"]`)
            ?.classList.contains("ppf-checked"),
      );

      if (!activeCondition) return;

      const currentlyChecked = this.querySelector(
        `.product-options-btns__container .product-variant[data-condition="${activeCondition}"]:has(input:checked)`,
      );
      if (
        currentlyChecked &&
        parseInt(currentlyChecked.dataset.invertory) > 0 &&
        !currentlyChecked.querySelector(".variant-is-in-cart")
      ) {
        return;
      }

      const nextVariant = Array.from(
        this.querySelectorAll(
          `.product-options-btns__container .product-variant[data-condition="${activeCondition}"]`,
        ),
      ).find(
        (variant) =>
          parseInt(variant.dataset.invertory) > 0 &&
          !variant.querySelector(".variant-is-in-cart"),
      );

      if (!nextVariant) return;

      nextVariant.querySelector("input")?.click();
      setTimeout(() => {
        this.checkIfAllVariantsAreInTheCart();
      }, 100);
    }

    updateVariantInput() {
      const productForms = this.getProductSection()?.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
      );
      if (!productForms) return;

      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }

    updateVariantStatuses() {
      const selectedOptionOneVariants = this.variantData.filter(
        (variant) => this.querySelector(":checked").value === variant.option1,
      );
      const inputWrappers = [...this.querySelectorAll(".product-form__input")];
      inputWrappers.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [
          ...option.querySelectorAll('input[type="radio"], option'),
        ];
        const previousOptionSelected =
          inputWrappers[index - 1].querySelector(":checked").value;
        const availableOptionInputsValue = selectedOptionOneVariants
          .filter(
            (variant) =>
              variant.available &&
              variant[`option${index}`] === previousOptionSelected,
          )
          .map((variantOption) => variantOption[`option${index + 1}`]);
        this.setInputAvailability(optionInputs, availableOptionInputsValue);
      });
    }

    setInputAvailability(elementList, availableValuesList) {
      elementList.forEach((element) => {
        const value = element.getAttribute("value");
        const availableElement = availableValuesList.includes(value);

        if (element.tagName === "INPUT") {
          element.classList.toggle("disabled", !availableElement);
        } else if (element.tagName === "OPTION") {
          element.innerText = availableElement
            ? value
            : window.variantStrings.unavailable_with_option.replace(
                "[value]",
                value,
              );
        }
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = this.getProductSection()?.querySelector(
        "pickup-availability",
      );
      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute("available");
        pickUpAvailability.innerHTML = "";
      }
    }

    removeErrorMessage() {
      let section = this.closest("section");
      if (window.location.href.includes("/pages/suites")) {
        section = this.closest("suite-product");
      }
      if (!section) return;

      const productForm = section.querySelector("product-form");
      if (productForm) productForm.handleErrorMessage();
    }

    updateVisiblePricesFromCurrentVariant() {
      const productSection = this.getProductSection();
      if (!productSection || !this.currentVariant) return;

      const formattedPrice = formatVariantMoney(this.currentVariant.price);
      const formattedCompareAtPrice =
        this.currentVariant.compare_at_price > 0
          ? formatVariantMoney(this.currentVariant.compare_at_price)
          : "";
      const formattedSavingsAmount =
        this.currentVariant.compare_at_price > 0
          ? formatVariantMoney(
              this.currentVariant.compare_at_price - this.currentVariant.price,
            )
          : "";

      const buyButtonPrice = productSection.querySelector("#buy-button-price");
      if (buyButtonPrice) {
        buyButtonPrice.textContent = formattedPrice;
      }

      const priceContainer = productSection.querySelector(
        `#price-${this.dataset.section}`,
      );
      if (!priceContainer) return;

      const priceDataContainer = priceContainer.querySelector(
        "[data-discounted-price-cents]",
      );
      if (priceDataContainer) {
        priceDataContainer.dataset.discountedPriceCents =
          this.currentVariant.price;
        priceDataContainer.dataset.originalPriceCents =
          this.currentVariant.compare_at_price || 0;
        priceDataContainer.dataset.savingsAmount =
          this.currentVariant.compare_at_price - this.currentVariant.price;
      }

      const mainPrice = priceContainer.querySelector('[aria-label="price"]');
      if (mainPrice) {
        mainPrice.textContent = formattedPrice;
      }

      priceContainer
        .querySelectorAll(".compare-at-price, .variant-item__old-price")
        .forEach((element) => {
          if (formattedCompareAtPrice) {
            element.textContent = formattedCompareAtPrice;
            element.classList.remove("hidden");
          } else {
            element.classList.add("hidden");
          }
        });

      priceContainer
        .querySelectorAll(".price-saved-box .font-bold")
        .forEach((element) => {
          element.textContent = formattedSavingsAmount;
        });

      priceContainer
        .querySelectorAll(".price-saved-box__price")
        .forEach((element) => {
          element.textContent = formattedSavingsAmount;
        });
    }

    renderProductInfo() {
      if (!this.currentVariant) return;

      const requestedVariantId = this.currentVariant.id;
      const sectionId = this.dataset.originalSection || this.dataset.section;
      const productSection = this.getProductSection();
      if (!productSection) return;
      const isSuitesPage = window.location.href.includes("/pages/suites");

      this.renderProductInfoController?.abort();
      this.renderProductInfoController = new AbortController();

      let fecthURL = `${
        this.dataset.url
      }?variant=${requestedVariantId}&section_id=product-variant-state&target_section_id=${
        this.dataset.section
      }&inventory_threshold=${this.dataset.inventoryThreshold || 10}&show_inventory_quantity=${
        this.dataset.showInventoryQuantity || false
      }`;
      if (isSuitesPage)
        fecthURL = `${this.dataset.url}?variant=${requestedVariantId}`;
      fetch(fecthURL, { signal: this.renderProductInfoController.signal })
        .then((response) => response.text())
        .then((responseText) => {
          if (
            !this.currentVariant ||
            this.currentVariant.id !== requestedVariantId
          )
            return;

          const html = new DOMParser().parseFromString(
            responseText,
            "text/html",
          );

          if (isSuitesPage) {
            this.dataset.originalSection = html.querySelector(
              ".product-main--section",
            ).dataset.section;
          }
          const destination = productSection.querySelector(
            `#price-${this.dataset.section}`,
          );
          const source = html.getElementById(
            `price-${this.dataset.originalSection || this.dataset.section}`,
          );

          const skuSource = html.getElementById(
            `Sku-${this.dataset.originalSection || this.dataset.section}`,
          );
          const skuDestination = productSection.querySelector(
            `#Sku-${this.dataset.section}`,
          );
          const inventorySource = html.getElementById(
            `Inventory-${this.dataset.originalSection || this.dataset.section}`,
          );
          const inventoryDestination = productSection.querySelector(
            `#Inventory-${this.dataset.section}`,
          );

          const volumePricingSource = html.getElementById(
            `Volume-${this.dataset.originalSection || this.dataset.section}`,
          );

          const pricePerItemDestination = productSection.querySelector(
            `#Price-Per-Item-${this.dataset.section}`,
          );
          const pricePerItemSource = html.getElementById(
            `Price-Per-Item-${this.dataset.originalSection || this.dataset.section}`,
          );

          const volumePricingDestination = productSection.querySelector(
            `#Volume-${this.dataset.section}`,
          );
          const qtyRules = productSection.querySelector(
            `#Quantity-Rules-${this.dataset.section}`,
          );
          const volumeNote = productSection.querySelector(
            `#Volume-Note-${this.dataset.section}`,
          );

          if (volumeNote) volumeNote.classList.remove("hidden");
          if (volumePricingDestination)
            volumePricingDestination.classList.remove("hidden");
          if (qtyRules) qtyRules.classList.remove("hidden");

          if (source && destination) {
            destination.innerHTML = source.innerHTML;
            this.updateStickyCTA();
          }
          if (inventorySource && inventoryDestination)
            inventoryDestination.innerHTML = inventorySource.innerHTML;
          if (skuSource && skuDestination) {
            skuDestination.innerHTML = skuSource.innerHTML;
            skuDestination.classList.toggle(
              "hidden",
              skuSource.classList.contains("hidden"),
            );
          }

          if (volumePricingSource && volumePricingDestination) {
            volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
          }

          if (pricePerItemSource && pricePerItemDestination) {
            pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
            pricePerItemDestination.classList.toggle(
              "hidden",
              pricePerItemSource.classList.contains("hidden"),
            );
          }

          const financeBoxSource = html.querySelector(".mpfs__finance-box");
          const financeBoxDestination =
            productSection.querySelector(".mpfs__finance-box");

          if (financeBoxSource && financeBoxDestination) {
            financeBoxDestination.innerHTML = financeBoxSource.innerHTML;
          }

          const price = productSection.querySelector(
            `#price-${this.dataset.section}`,
          );

          if (price) price.classList.remove("hidden");

          if (inventoryDestination)
            inventoryDestination.classList.toggle(
              "hidden",
              inventorySource.innerText === "",
            );

          let addButtonUpdated = html.getElementById(
            `ProductSubmitButton-${sectionId}`,
          );

          if (isSuitesPage) {
            addButtonUpdated = html.getElementById(
              `ProductSubmitButton-${this.dataset.originalSection}`,
            );
          }

          this.toggleAddButton(
            addButtonUpdated
              ? addButtonUpdated.hasAttribute("disabled")
              : !this.currentVariant.available,
            window.variantStrings.soldOut,
          );

          if (addButtonUpdated) {
            const currentButton = productSection.querySelector(
              `#ProductSubmitButton-${this.dataset.section}`,
            );
            if (currentButton) {
              const updatedPriceSpan = addButtonUpdated.querySelector(
                "[data-variant-price]",
              );
              const currentPriceSpan = currentButton.querySelector(
                "[data-variant-price]",
              );

              if (updatedPriceSpan && currentPriceSpan) {
                currentPriceSpan.textContent = updatedPriceSpan.textContent;
              }

              const updatedBundleVariants = addButtonUpdated.getAttribute(
                "data-bundle-variants",
              );
              if (updatedBundleVariants) {
                currentButton.setAttribute(
                  "data-bundle-variants",
                  updatedBundleVariants,
                );
              }
            }
          }

          this.updateVisiblePricesFromCurrentVariant();
          this.updateStickyCTA();

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId,
              html,
              variant: this.currentVariant,
            },
          });
        })
        .catch((error) => {
          if (error.name !== "AbortError") {
            console.error(error);
          }
        });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = this.getProductForm();
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] div span');
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute("disabled", "disabled");
        if (text) addButtonText.textContent = "Sold out";
      } else {
        addButton.removeAttribute("disabled");
        addButtonText.textContent = window.variantStrings.addToCart;
      }

      if (!modifyClass) return;
    }

    setUnavailable() {
      const productSection = this.getProductSection();
      const button = this.getProductForm();
      if (!button || !productSection) return;

      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] div span');
      const price = productSection.querySelector(
        `#price-${this.dataset.section}`,
      );
      const inventory = productSection.querySelector(
        `#Inventory-${this.dataset.section}`,
      );
      const sku = productSection.querySelector(`#Sku-${this.dataset.section}`);
      const pricePerItem = productSection.querySelector(
        `#Price-Per-Item-${this.dataset.section}`,
      );
      const volumeNote = productSection.querySelector(
        `#Volume-Note-${this.dataset.section}`,
      );
      const volumeTable = productSection.querySelector(
        `#Volume-${this.dataset.section}`,
      );
      const qtyRules = productSection.querySelector(
        `#Quantity-Rules-${this.dataset.section}`,
      );

      if (!addButton) return;
      if (addButtonText)
        addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add("hidden");
      if (inventory) inventory.classList.add("hidden");
      if (sku) sku.classList.add("hidden");
      if (pricePerItem) pricePerItem.classList.add("hidden");
      if (volumeNote) volumeNote.classList.add("hidden");
      if (volumeTable) volumeTable.classList.add("hidden");
      if (qtyRules) qtyRules.classList.add("hidden");
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    getProductSection() {
      if (!this.productSection?.isConnected) {
        this.productSection = this.closest(".product-main--section");
      }
      return this.productSection;
    }

    getProductInfo() {
      if (!this.productInfo?.isConnected) {
        this.productInfo = this.closest("product-info");
      }
      return this.productInfo;
    }

    getHostSection() {
      if (!this.hostSection?.isConnected) {
        this.hostSection = this.closest("section");
      }
      return this.hostSection;
    }

    refreshMediaSliders() {
      const hostSection = this.getHostSection();
      if (!hostSection) return;

      const thumbSlider = hostSection.querySelector(
        ".thumbnail-slider.slider-mobile-gutter.quick-add-hidden",
      );
      thumbSlider?.classList.remove("hide-gallery-element");

      const sliderComponents = Array.from(
        hostSection.querySelectorAll("media-gallery slider-component"),
      );

      requestAnimationFrame(() => {
        sliderComponents.forEach((sliderComponent) => {
          sliderComponent.resetPages?.();
          sliderComponent.update?.();
        });

        const activeThumbnailButton = thumbSlider?.querySelector(
          'button[aria-current="true"]',
        );
        const activeThumbnailItem = activeThumbnailButton?.closest("li");
        if (
          activeThumbnailItem &&
          !activeThumbnailItem.classList.contains("hide-image") &&
          !activeThumbnailItem.classList.contains("custom-hidden")
        ) {
          return;
        }

        thumbSlider
          ?.querySelector("li:not(.hide-image):not(.custom-hidden) button")
          ?.click();
      });
    }

    getFirstVisibleMediaId(productSection) {
      return productSection
        .querySelector(
          ".product__media-item[data-media-id]:not(.hide-image):not(.custom-hidden)",
        )
        ?.getAttribute("data-media-id");
    }

    isMediaVisible(productSection, mediaId) {
      const mediaItem = productSection.querySelector(
        `.product__media-item[data-media-id="${mediaId}"]`,
      );
      return (
        !!mediaItem &&
        !mediaItem.classList.contains("hide-image") &&
        !mediaItem.classList.contains("custom-hidden")
      );
    }

    getCartData(forceRefresh = false) {
      const cacheTtl = 1000;
      const isCacheFresh = Date.now() - this.cartDataFetchedAt < cacheTtl;

      if (!forceRefresh && this.cartData && isCacheFresh) {
        return Promise.resolve(this.cartData);
      }

      if (!forceRefresh && this.cartRequestPromise) {
        return this.cartRequestPromise;
      }

      this.cartRequestPromise = fetch(window.Shopify.routes.root + "cart.js")
        .then((response) => response.json())
        .then((data) => {
          this.cartData = data;
          this.cartDataFetchedAt = Date.now();
          return data;
        })
        .finally(() => {
          this.cartRequestPromise = null;
        });

      return this.cartRequestPromise;
    }

    checkIfAllVariantsAreInTheCart(cartData = null) {
      if (
        !window.location.href.includes("variant=") ||
        window.location.href.includes("old_key=")
      ) {
        return;
      }
      const atc = this.getProductInfo()?.querySelector(".product-form__submit");
      if (!atc) return;

      atc.classList.remove("disabled");
      atc.querySelector("div span").textContent = "Add to cart";
      const selectedVar = this.querySelector(
        ".product-variant:has(input:checked)",
      );
      if (!selectedVar) return;

      Promise.resolve(cartData || this.getCartData()).then((data) => {
        const variants = data.items;
        const variant = variants.find(
          (variant) =>
            variant.variant_id == parseInt(selectedVar.dataset.variantId),
        );

        if (variant) {
          const qty = variant.quantity;
          const invertory = selectedVar.dataset.invertory;

          if (invertory) {
            if (parseInt(invertory) - qty <= 0) {
              setTimeout(() => {
                const currentlySelected = this.querySelector(
                  ".product-variant:has(input:checked)",
                );
                if (
                  currentlySelected?.dataset.variantId !==
                  selectedVar.dataset.variantId
                ) {
                  return;
                }
                atc.classList.add("disabled");
                atc.querySelector("div span").textContent = "Added to Cart";
                atc.classList.add("added-to-the-cart");
                this.checkIfVariantIsInCart(data);
              }, 700);
            }
          }
        }
      });
    }

    checkIfVariantIsInCart(cartData = null) {
      Promise.resolve(cartData || this.getCartData()).then((data) => {
        const variantsInCart = data.items.map((item) => item.variant_id);

        const productOptions = this.querySelectorAll(
          ".product-options-btns__container .product-variant",
        );

        productOptions.forEach((option) => {
          if (variantsInCart.includes(parseInt(option.dataset.variantId))) {
            if (!option.querySelector(".variant-is-in-cart")) {
              const div = document.createElement("div");
              div.classList.add("variant-is-in-cart");
              div.innerHTML = this.variantInCartBadgeSvg;
              option.appendChild(div);
            }
          }
        });
        this.maybeSelectNextAvailableVariantForCondition();
      });
      window.dispatchEvent(new CustomEvent("check::variant-in-cart"));
    }

    updateStickyCTA() {
      const stickyCTAContainer = document.getElementById(
        "sticky-cta-container",
      );

      if (!stickyCTAContainer || !this.currentVariant) {
        return;
      }

      stickyCTAContainer.setAttribute(
        "data-variant-id",
        this.currentVariant.id,
      );
      stickyCTAContainer.setAttribute(
        "data-is-available",
        this.currentVariant.available,
      );

      const event = new CustomEvent("variant-change", {
        detail: {
          variantId: this.currentVariant.id,
          available: this.currentVariant.available,
          price: this.currentVariant.price,
          compareAtPrice: this.currentVariant.compare_at_price || 0,
          formattedPrice: formatVariantMoney(this.currentVariant.price),
        },
      });
      document.dispatchEvent(event);
    }
  }

  customElements.define("variant-selects", VariantSelects);
}

if (!customElements.get("product-recommendations")) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.recommendationsObserver = null;
      this.priceUpdateRaf = null;
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector(
              "product-recommendations",
            );

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (
              !this.querySelector("slideshow-component") &&
              this.classList.contains("complementary-products")
            ) {
              this.remove();
            }

            if (html.querySelector(".grid__item")) {
              this.classList.add("product-recommendations--loaded");
            }

            this.updateRecommendationPrices();
            this.observeRecommendationPriceChanges();
          })
          .catch((e) => {
            console.error(e);
          });
      };

      this.intersectionObserver = new IntersectionObserver(
        handleIntersection.bind(this),
        {
          rootMargin: "0px 0px 400px 0px",
        },
      );
      this.intersectionObserver.observe(this);
    }

    disconnectedCallback() {
      this.intersectionObserver?.disconnect();
      this.recommendationsObserver?.disconnect();
      if (this.priceUpdateRaf) {
        cancelAnimationFrame(this.priceUpdateRaf);
        this.priceUpdateRaf = null;
      }
    }

    scheduleRecommendationPriceUpdate() {
      if (this.priceUpdateRaf) return;

      this.priceUpdateRaf = requestAnimationFrame(() => {
        this.priceUpdateRaf = null;
        this.updateRecommendationPrices();
      });
    }

    observeRecommendationPriceChanges() {
      this.recommendationsObserver?.disconnect();
      this.recommendationsObserver = new MutationObserver(() => {
        this.scheduleRecommendationPriceUpdate();
      });
      this.recommendationsObserver.observe(this, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    updateRecommendationPrices() {
      this.querySelectorAll(".price-remove:not(:has(.new-price))").forEach(
        (el) => {
          const customizedPriceElement = el.querySelector(
            ".samitaWS-customized-price",
          );
          if (customizedPriceElement) {
            const currentPrice = getNumberFromstring(
              customizedPriceElement.textContent,
            );
            const oldPrice = getNumberFromstring(
              el.closest(".product-card-wrapper")?.dataset?.ogPrice,
            );
            const discount = (100 * (oldPrice - currentPrice)) / oldPrice;
            if (parseInt(discount) > 2)
              el.innerHTML = `<span class="old-price" style="text-decoration:line-through;display: none">$${oldPrice}</span>
                <span class="new-price">$${currentPrice}</span>
                <span class="percent-saved"
                  >
                  ${parseInt(discount)}% LESS THAN RETAIL
                </span>`;
          }
        },
      );
    }
  }

  customElements.define("product-recommendations", ProductRecommendations);
}

window.closeTooltip = function closeTooltip() {
  document.querySelectorAll(".product__media-tooltip-open").forEach((el) => {
    el.style.setProperty("display", "none", "important");
  });
  document.querySelectorAll(".product__media-tooltip-expand").forEach((el) => {
    el.style.setProperty("display", "none", "important");
  });
  document.querySelectorAll(".product__media-tooltip-closed").forEach((el) => {
    el.style.setProperty("display", "flex", "important");
  });
};

window.openTooltip = function openTooltip() {
  document.querySelectorAll(".product__media-tooltip-open").forEach((el) => {
    el.style.setProperty("display", "flex", "important");
  });
  document.querySelectorAll(".product__media-tooltip-closed").forEach((el) => {
    el.style.setProperty("display", "none", "important");
  });
};

window.expandTooltip = function expandTooltip() {
  document.querySelectorAll(".product__media-tooltip-expand").forEach((el) => {
    el.style.setProperty("display", "flex", "important");
  });
  document.querySelectorAll(".product__media-tooltip-open").forEach((el) => {
    el.style.setProperty("display", "none", "important");
  });
};

window.shrinkTooltip = function shrinkTooltip() {
  document.querySelectorAll(".product__media-tooltip-expand").forEach((el) => {
    el.style.setProperty("display", "none", "important");
  });
  document.querySelectorAll(".product__media-tooltip-open").forEach((el) => {
    el.style.setProperty("display", "flex", "important");
  });
};

window.tooltipToggle = function tooltipToggle() {
  const expandTooltipEl = document.querySelector(
    ".product__media-tooltip-expand",
  );
  const openTooltipEl = document.querySelector(".product__media-tooltip-open");

  if (!expandTooltipEl || !openTooltipEl) return;

  const isExpanded =
    window.getComputedStyle(expandTooltipEl).display !== "none";

  if (isExpanded) {
    window.shrinkTooltip();
  } else {
    window.expandTooltip();
  }
};
